import * as React from "react";
import { FormatTemplateSearch } from "@/formatTemplate/components/FormatTemplateSearch";
import { useContentSlideStore } from "@/state/contentSlideStore";
import useFormatTemplates from "@/utils/formatTemplate/useFormatTemplates";
import useFormatTemplatesRecentlyUsed from "@/utils/formatTemplate/useRecentFormatTemplates";

type FormattingSelectionStepProps = {
  impliedColors?: boolean;
};

export default function FormattingSelectionStep({ impliedColors = false }: FormattingSelectionStepProps) {
  const selectedFormatTemplateId = useContentSlideStore((s) => s.selectedFormatTemplateId);
  const setSelectedFormatTemplateId = useContentSlideStore((s) => s.setSelectedFormatTemplateId);

  const { formatTemplates } = useFormatTemplates(10);
  const { formatTemplatesRecentlyUsed } = useFormatTemplatesRecentlyUsed(10);
  const limitedRecentlyUsedTemplates = formatTemplatesRecentlyUsed?.slice(0, 10) ?? [];

  React.useEffect(() => {
    if (selectedFormatTemplateId != null) return;
    const primaryRecent = limitedRecentlyUsedTemplates.find((t: { isPrimary?: boolean }) => t.isPrimary);
    if (primaryRecent) {
      setSelectedFormatTemplateId(primaryRecent.id);
      return;
    }
    const primaryAvailable = formatTemplates?.find((t: { isPrimary?: boolean }) => t.isPrimary);
    if (primaryAvailable) {
      setSelectedFormatTemplateId(primaryAvailable.id);
    }
  }, [
    formatTemplates,
    limitedRecentlyUsedTemplates,
    selectedFormatTemplateId,
    setSelectedFormatTemplateId,
  ]);

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden text-sm text-gray-800">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <FormatTemplateSearch
          isSelectionTemplate
          selectionMode
          hideStarButtons
          hidePrimaryLegend
          showSelectionLegend
          hideSelectionIntroText
          selectedTemplateId={selectedFormatTemplateId}
          onTemplateSelect={(template) => setSelectedFormatTemplateId(template?.id ?? null)}
          hideRing
          selectionBorderColor={"#FF5C35"}
          impliedColors={impliedColors}
        />
      </div>
    </div>
  );
}
